// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1kL7B","bigColWidth":"Table_bigColWidth__2rrCH","biggerColWidth":"Table_biggerColWidth__3wxYt","row":"Table_row__22eu4","col":"Table_col___5rzb"};